import { sendPost } from '@/utils/request.js';

export function getFooterContent(data) {
  const url = '/api/website/get';
  return sendPost({ url, data});
}
